<tmo-dynamic-modal
  [modal]="restoreServiceModal"
  [attr.aria-label]="configurableData?.resumeLineService"
  (keyup.esc)="closeRestoreServiceModal()"
  [modal]="restoreServiceModal"
  #onModalBodyFocus
>
  <ng-container header>
    <!-- Grey X in top right corner -->
    <div class="modal-logo-close" #onModalBodyFocus>
      <!-- T-Mobile logo in top left corner -->
      <i class="logo-icon t-icon t-icon-logo"></i
      ><a
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closeRestoreServiceModal()"
        [attr.aria-label]="configurableData?.clickToClose"
        id="cta-click-to-close-5"
        ><i class="fa fa-times"></i
      ></a>
    </div>
    <!-- Header -->
    <h3>{{ configurableData?.resumeLineService }}</h3>
  </ng-container>
  <div class="row" id="restore-service-error" *ngIf="restoreServiceErrorMessage?.length">
    <div class="col-12 m-t-md m-b-md">
      <tmo-error-message-detail
        [errorMessage]="restoreServiceErrorMessage"
        [modalName]="'restoreServiceModal'"
      ></tmo-error-message-detail>
    </div>
  </div>
  <div class="row" id="suspended-line-error" *ngIf="!isSuspended">
    <div class="col-12 m-t-md m-b-md">
      <tmo-error-message-detail
        [errorMessage]="isSuspendedErrorMessage"
        [modalName]="'restoreServiceModal'"
      ></tmo-error-message-detail>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <tmo-multiline-msisdn-dropdown
        [isLineDetailsPage]="false"
        (isMsisdnUpdated)="onLineSelection($event)"
      >
      </tmo-multiline-msisdn-dropdown>
    </div>
  </div>
  <div class="row" *ngIf="isDeviceAssociated && !isManageBlackListSuccess">
    <div class="col-12 m-t-md">
      <tmo-radio-button
        type="radio"
        [disabled]="!isSuspended"
        id="block-unblock"
        name="blockImei"
        [selectedValue]="selectedStatus"
        [values]="!isImeiValid ? configurableData?.keepImeiBlocked : configurableData?.blockMyImei"
        [(ngModel)]="selectedStatus"
        (onSelect)="selectToBlockUnblock($event)"
        [aria-label]="
          !isImeiValid
            ? configurableData?.keepImeiBlocked +
              ' ' +
              configurableData?.optionSelectedFor +
              ' ' +
              configurableData?.resumeLineService
            : configurableData?.blockMyImei +
              ' ' +
              configurableData?.optionSelectedFor +
              ' ' +
              configurableData?.resumeLineService
        "
        [id]="'tmo-radio-button-block-imei'"
      >
        {{ !isImeiValid ? configurableData?.keepImeiBlocked : configurableData?.blockMyImei }}
      </tmo-radio-button>
    </div>
  </div>
  <div class="row" *ngIf="isDeviceAssociated && !isManageBlackListSuccess">
    <div class="col-12 m-t-md">
      <tmo-radio-button
        type="radio"
        [disabled]="!isSuspended"
        id="block-unblock-radioButton"
        name="blockImei"
        [selectedValue]="selectedStatus"
        [values]="
          !isImeiValid ? configurableData?.unBlockMyImei : configurableData?.doNotBlockMyImei
        "
        [(ngModel)]="selectedStatus"
        (onSelect)="selectToBlockUnblock($event)"
        [aria-label]="
          !isImeiValid
            ? configurableData?.unBlockMyImei +
              ' ' +
              configurableData?.optionSelectedFor +
              ' ' +
              configurableData?.resumeLineService
            : configurableData?.doNotBlockMyImei +
              ' ' +
              configurableData?.optionSelectedFor +
              ' ' +
              configurableData?.resumeLineService
        "
        [id]="'tmo-radio-button-block-imei-2'"
      >
        {{ !isImeiValid ? configurableData?.unBlockMyImei : configurableData?.doNotBlockMyImei }}
      </tmo-radio-button>
    </div>
  </div>
  <div class="row m-t-lg">
    <div class="col-12">
      <p class="small">{{ configurableData?.clickAccept }}:</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12" *ngIf="isDeviceAssociated; else showNoDeviceSssociated">
      <ul class="m-l-lg">
        <li class="p m-t-sm">{{ configurableData?.unblockDevice }}</li>
        <li class="p m-t-md">{{ unblockServiceText }}</li>
      </ul>
    </div>
    <ng-template #showNoDeviceSssociated>
      <ul class="m-l-lg">
        <li class="p m-t-sm">{{ configurableData?.suspendNotification }}</li>
      </ul>
    </ng-template>
  </div>
  <div class="row">
    <div class="col-12 text-center">
      <tmo-inline-spinner [setDelay]="!showSpinner"></tmo-inline-spinner>
    </div>
  </div>
  <ng-container footer>
    <div class="buttons-container button-spacing">
      <tmo-button
        [button]="acceptButton"
        [attr.aria-label]="acceptButton?.name"
        [disabled]="isDisabled()"
        (click)="restoreServices()"
        id="tmo-button-accept-button-2"
      >
        {{ acceptButton?.name }}
      </tmo-button>
    </div>
  </ng-container>
</tmo-dynamic-modal>
